import { $ } from './../../helpers/query'
import Scrollbar from 'smooth-scrollbar';
import {SectionAnimationTemplate} from './SectionAnimationTemplate'

export class PhotosAnimation extends SectionAnimationTemplate {
  constructor() {
    super();
    this.photosSection = document.querySelector('#photos-section');
    this.photosCont = this.photosSection.querySelector('.photos__container');
    this.photosBeforeClone = this.cloneNextSibling(this.photosSection.previousElementSibling);
    this.photosAfterClone = this.clonePrevSibling(this.photosSection.nextElementSibling);
  }

  // 1. Interract whith Previous section
  // -- 1.1. Interract forward
  onVisitDown() {
    this.hideVideo()
    if (this.photosBeforeClone) {
      this.photosBeforeClone.classList.remove('invisible')
      setTimeout(() => {
        this.photosBeforeClone.classList.add('invisible')
      }, this.ANIM_DUR + this.EXTRA_DUR)
    }
  }

  // -- 1.2. Interract back
  onLeaveUp() {
    this.photosCont.classList.add('invisible')
    setTimeout(() => {
      this.photosCont.classList.remove('invisible')
    }, this.ANIM_DUR + this.EXTRA_DUR)
  }

  // 2. Interract whith Next section
  // -- 2.1. Interract forward
  onLeaveDown() {
    this.photosCont.classList.add('invisible')
    setTimeout(() => {
      this.photosCont.classList.remove('invisible')
    }, this.ANIM_DUR + this.EXTRA_DUR)
  }

  // -- 2.2. Interract back
  onVisitUp() {
    this.hideVideo()
    const photosSlider = Scrollbar.get(document.querySelector('#photos-section .photos__carousel'));
    if (photosSlider.scrollLeft == photosSlider.limit.x - 1) {
      this.photosAfterClone.querySelector('.autoslider-wrapper').classList.add('autoslider-wrapper--end')
    } else {
      this.photosAfterClone.querySelector('.autoslider-wrapper').classList.remove('autoslider-wrapper--end')
    }
    this.photosAfterClone.classList.remove('invisible')
    setTimeout(() => {
      this.photosAfterClone.classList.add('invisible')
    }, this.ANIM_DUR + this.EXTRA_DUR)
  }
}
